import { __extends } from "tslib";
import { GetRecommenderConfigurationsRequest, GetRecommenderConfigurationsResponse } from "../models/index";
import { deserializeAws_restJson1GetRecommenderConfigurationsCommand, serializeAws_restJson1GetRecommenderConfigurationsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetRecommenderConfigurationsCommand = /** @class */ (function (_super) {
    __extends(GetRecommenderConfigurationsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetRecommenderConfigurationsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetRecommenderConfigurationsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetRecommenderConfigurationsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetRecommenderConfigurationsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetRecommenderConfigurationsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetRecommenderConfigurationsCommand(input, context);
    };
    GetRecommenderConfigurationsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetRecommenderConfigurationsCommand(output, context);
    };
    return GetRecommenderConfigurationsCommand;
}($Command));
export { GetRecommenderConfigurationsCommand };
//# sourceMappingURL=GetRecommenderConfigurationsCommand.js.map